import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentPath, currentDomain } from "../Index"
import { createPortal } from "react-dom"
import { promotionsData } from "../data/PromotionData"
import { useGlobalContext } from "../data/GlobalContext"
import PromotionBar from "../snippets/PromotionBar"
import LuckyDraw8 from "../snippets/games/LuckyDraw8"
import DoubleUpChallenge from "../snippets/games/DoubleUpChallenge"
import Deposit from "../transactions/Deposit"

import ModulesLotteryDraw from "./promotion_modules/modules_lotterDraw"
import ModulePeraBayong from "./promotion_modules/modules_peraBayong"
import ModuleRaceToRiches from "./promotion_modules/modules_racetoRiches"
import ModuleKingOfTheReels from "./promotion_modules/modules_kingOfTheReels"
import ModuleJustDoYourBest from "./promotion_modules/modules_justDoYourBest"
import ModuleFaChaiGrandSpinAle from "./promotion_modules/modules_fcGrandSpinAle"
import { faL } from "@fortawesome/free-solid-svg-icons"
import ModuleFlexiShowDown from "./promotion_modules/modules_flexiSpinShowdown"
import ModuleCQ9Funalo from "./promotion_modules/modules_cq9Funalo"

export default function Promotions() {
  const [currentFilter, setCurrentFilter] = useState("All")
  const [isAnimating, setIsAnimating] = useState(false)
  const [isShowDoubleUp, setIsShowDoubleUp] = useState(false)
  const [isShowViewEntry, setIsShowViewEntry] = useState(false)
  const [activeModal, setActiveModal] = useState("")
  const { showMysteryFridayBtn, doubleUpMaxAmount, doubleUpTurnover } =
    useGlobalContext()
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  // Track if the screen is mobile (1024px or below)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024)
  const [isDepositOpen, setIsDepositOpen] = useState(false)
  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    // When any popup is open, prevent body scroll
    document.body.style.overflow = activeModal ? "hidden" : "auto"
    return () => {
      document.body.style.overflow = "auto"
    }
  }, [activeModal])

  // Listen to window resize to update mobile state.
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024)
    }

    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const modalComponents = {
    "2/30 Lottery Draw": ModulesLotteryDraw,
    "Pera O Bayong": ModulePeraBayong,
    "Race to Riches": ModuleRaceToRiches,
    "King of the Reels": ModuleKingOfTheReels,
    "JDB Exclusive Promo": ModuleJustDoYourBest,
    "FC Grand Spin-Ale": ModuleFaChaiGrandSpinAle,
    "Flexi-Spin Showdown": ModuleFlexiShowDown,
    "CQ9 Funalo": ModuleCQ9Funalo,
  }

  const statuses = Array.from(
    new Set(
      promotionsData
        .map((promotion) => promotion.status)
        .filter((status) => status && status.trim() !== "")
    )
  )

  const order = { daily: 1, weekly: 2 }
  const sortedStatuses = statuses.sort((a, b) => {
    const aKey = order[a.toLowerCase()] || 3
    const bKey = order[b.toLowerCase()] || 3
    if (aKey !== bKey) {
      return aKey - bKey
    }
    return a.localeCompare(b)
  })

  const uniqueFilters =
    sortedStatuses.length > 0 ? ["All", ...sortedStatuses] : []

  // Function to handle filter change with fade-out then update
  const handleFilterChange = (filter) => {
    if (filter === currentFilter) return
    setIsAnimating(true)
    setTimeout(() => {
      setCurrentFilter(filter)
      setIsAnimating(false)
    }, 100)
  }

  const filteredPromotions =
    currentFilter === "All"
      ? promotionsData
      : promotionsData.filter((promotion) => promotion.status === currentFilter)

  // Lookup the active modal component using the promotion title
  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const handleClick = () => {
    window.location.href = "/profile#wallet" // Replace with your URL
  }

  const handlePeraOBayongClick = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else if (showMysteryFridayBtn) {
      setActiveModal("Pera O Bayong")
    } else {
      handleClick()
    }
  }
  const handleKingOfReels = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("King of the Reels")
    }
  }

  const handleFaChaiGrandSpinAle = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("FC Grand Spin-Ale")
    }
  }
  const handleFlexiSpinShowdown = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("Flexi-Spin Showdown")
    }
  }

  const handleCQ9Funalo = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("CQ9 Funalo")
    }
  }

  const handleViewEntry = () => {
    setIsShowViewEntry(true)
  }

  const handleJDB = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("JDB Exclusive Promo")
    }
  }
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Promotion - FGH - Your One-Stop Gaming Site</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      {isShowDoubleUp && <DoubleUpChallenge />}
      {isShowViewEntry && (
        <LuckyDraw8 onClose={() => setIsShowViewEntry(false)} />
      )}
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-page-content">
            <h1 className="fgh-h1-style normal-margin-bottom">
              Exclusive Casino Bonuses Just for You
            </h1>
            <label className="fgh-normal-label-style standard-margin-bottom">
              Your Offers Are In – Don’t Miss Out
            </label>
            {uniqueFilters.length > 0 && (
              <div className="promotion-page-filter">
                {isMobile ? (
                  <select
                    value={currentFilter}
                    onChange={(e) => handleFilterChange(e.target.value)}
                  >
                    {uniqueFilters.map((filter, index) => (
                      <option key={index} value={filter}>
                        {filter}
                      </option>
                    ))}
                  </select>
                ) : (
                  <ul>
                    {uniqueFilters.map((filter, index) => (
                      <li
                        key={index}
                        className={`promotion-filter-status ${
                          currentFilter === filter ? "active" : ""
                        }`}
                        onClick={() => handleFilterChange(filter)}
                      >
                        {filter}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
            <div
              className={`promotion-items-container ${
                isAnimating ? "promotion-fade-out" : "promotion-fade-in"
              }`}
            >
              {filteredPromotions.map((data) => (
                <div key={data.id} className="promotion-item">
                  <div className="promotion-image">
                    <img src={data.imgSrc} alt={data.title} />
                    <div className="promotion-image-overlay"></div>
                  </div>
                  {data.status && (
                    <div
                      className={`promotion-item-ribbon ${data.promotionMessage.class}`}
                    >
                      {data.promotionMessage.text}
                    </div>
                  )}
                  <div className="promotion-item-content">
                    <div className="promotion-info">
                      <h2>{data.title}</h2>
                      <label>{data.subHeading}</label>
                    </div>
                    <div className="promotion-cta">
                      {showMysteryFridayBtn &&
                        data.title === "Pera O Bayong" && (
                          <button onClick={handlePeraOBayongClick}>
                            Claim Your Prize
                          </button>
                        )}
                      {isLoggedIn && data.title === "King of the Reels" && (
                        <button onClick={handleKingOfReels}>Leaderboard</button>
                      )}
                      {isLoggedIn && data.title === "FC Grand Spin-Ale" && (
                        <button onClick={handleFaChaiGrandSpinAle}>
                          Leaderboard
                        </button>
                      )}
                      {isLoggedIn && data.title === "Flexi-Spin Showdown" && (
                        <button onClick={handleFlexiSpinShowdown}>
                          Leaderboard
                        </button>
                      )}
                      {isLoggedIn && data.title === "CQ9 Funalo" && (
                        <button onClick={handleCQ9Funalo}>Leaderboard</button>
                      )}
                      {isLoggedIn && data.title === "JDB Exclusive Promo" && (
                        <button onClick={handleJDB}>Leaderboard</button>
                      )}
                      {isLoggedIn && data.title === "8PM Recovery Hour" && (
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsDepositOpen(true)}
                        >
                          Deposit Now
                        </button>
                      )}
                      {data.title === "Double Up" &&
                        isLoggedIn &&
                        doubleUpMaxAmount &&
                        doubleUpTurnover >= 100000 && (
                          <button
                            onClick={() => {
                              setIsShowDoubleUp(false)
                              setTimeout(() => setIsShowDoubleUp(true), 0)
                            }}
                          >
                            Play Now
                          </button>
                        )}

                      {data.title === "8's Your Lucky Draw" && isLoggedIn && (
                        <button
                          onClick={() => {
                            handleViewEntry()
                          }}
                        >
                          View Entry
                        </button>
                      )}

                      {data.btnTxt && (
                        <>
                          {data.title === "Saturday Spin Surprize" && (
                            <PromotionBar />
                          )}
                          {isLoggedIn && (
                            <button
                              style={{
                                display:
                                  data.title ===
                                    "Exclusive Rolling Commission" ||
                                  data.title === "Pera O Bayong" ||
                                  data.title === "Double Up" ||
                                  data.title === "JDB Exclusive Promo" ||
                                  data.title === "Pragmatic Play Daily" ||
                                  data.title === "JolliPlay Free Spins" ||
                                  data.title === "Recovery Bonus" ||
                                  data.title ===
                                    "Pragmatic Play Zombie School" ||
                                  data.title ===
                                    "Jolliplay Exclusive Campaign" ||
                                  data.title ===
                                    "FGH RECOVERY BONUS is back!" ||
                                  data.title === "JolliPlay Free Spins Code" ||
                                  data.title === "FC Grand Spin-Ale" ||
                                  data.title === "8's Your Lucky Draw" ||
                                  data.title === "JolliPlay Free Spins Code" ||
                                  data.title === "Flexi-Spin Showdown" ||
                                  data.title === "8PM Recovery Hour" || 
                                  data.title === "CQ9 Funalo"
                                    ? "none"
                                    : "block",
                              }}
                              onClick={() => {
                                if (
                                  data.specialLink &&
                                  data.specialLink.trim() !== ""
                                ) {
                                  const a = document.createElement("a")
                                  a.href = data.specialLink
                                  a.target = "_blank"
                                  a.rel = "nofollow"
                                  document.body.appendChild(a)
                                  a.click()
                                  document.body.removeChild(a)
                                } else if (data.onClickFunction) {
                                  if (
                                    data.onClickFunction === "handleOpenModule"
                                  ) {
                                    if (data.title === "2/30 Lottery Draw") {
                                      if (
                                        !document.body.classList.contains(
                                          "IsLoggedIn"
                                        )
                                      ) {
                                        window.location.href = "/promotion"
                                        return
                                      }
                                    }

                                    if (modalComponents[data.title]) {
                                      if (data.title === "Pera O Bayong") {
                                        if (!isLoggedIn) {
                                          window.location.href = "/promotion"
                                        } else if (showMysteryFridayBtn) {
                                          setActiveModal(data.title)
                                        } else {
                                          handleClick()
                                        }
                                      } else if (
                                        data.title === "2/30 Lottery Draw"
                                      ) {
                                        setActiveModal(data.title)
                                      } else if (
                                        data.title === "8's Your Lucky Draw"
                                      ) {
                                        setActiveModal(data.title)
                                      } else {
                                        setActiveModal(data.title)
                                      }
                                    } else {
                                      console.warn(
                                        `No modal mapped for title: ${data.title}`
                                      )
                                    }
                                  } else if (
                                    typeof data.onClickFunction === "function"
                                  ) {
                                    data.onClickFunction()
                                  }
                                }
                              }}
                            >
                              {data.btnTxt}
                            </button>
                          )}
                        </>
                      )}
                      <a href={data.tncLink}>Details</a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="fgh-section-margin fgh-section-articles">
            <div className="fgh-main-page-content">
              <h2 className="fgh-h2-style standard-margin-bottom">
                FGH – Best Casino Site, Just for You
              </h2>
              <p className="fgh-paragraph-standard-style">
                Get ready to spin, win, and have a blast! At FGH, we bring you a
                thrilling collection of online slots designed to keep the
                excitement rolling. Whether you're here for big wins, fun
                themes, or just some good old-fashioned luck, we’ve got
                something for everyone. No complicated rules, just pure
                entertainment at your fingertips!
              </p>
              <p className="fgh-paragraph-standard-style">
                So, why wait? Dive into the action, explore our wide range of
                slots, and let the reels do the talking. Who knows? Your next
                spin could be the lucky one!
              </p>
            </div>
          </div>
        </div>
      </div>
      {isDepositOpen &&
        createPortal(
          <div className="modal-portal">
            <Deposit
              onClose={() => setIsDepositOpen(false)}
              defaultBonusName="New Member Package Bonus"
            />
          </div>,
          document.body
        )}
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
    </>
  )
}
